import type { PureFunction } from '@bonsai-components/utility-types';
import { formatLocaleNumber, getCurrentLocale } from '../helpers/i18n.helper';

type i18nUtilities = {
  formatNumber: PureFunction<
    { value: number; humanReadable?: boolean },
    string
  >;
};

const humanReadableLocaleNumberFormatter = Intl.NumberFormat(
  getCurrentLocale(),
  {
    notation: 'compact',
    maximumSignificantDigits: 3
  }
);

export const useI18n = (): i18nUtilities => {
  const formatNumber: i18nUtilities['formatNumber'] = ({
    value,
    humanReadable = false
  }) => {
    return humanReadable
      ? humanReadableLocaleNumberFormatter.format(value)
      : formatLocaleNumber(value);
  };

  return { formatNumber };
};
